import React, { PropTypes } from 'react'
import Button from '../Button'
import classnames from 'classnames'
import { IconSubmit } from 'icons'
import styles from './SubmitButton.scss'

const SubmitButton = ({
  className,
  children,
  complete,
  completeText,
  disabled,
  isLarge,
  submitting,
  submittingText,
  type,
  ...rest
}) => {
  const iconClasses = {
    [styles.submitting]: submitting,
    [styles.complete]: complete,
  }

  const buttonClasses = {
    [styles.disabled]: complete,
    [styles.isLarge]: isLarge,
  }

  const disabledState = (disabled || submitting || complete)

  let pos = styles.defaultPos
  if (complete) {
    pos = styles.completePos
  } else if (submitting) {
    pos = styles.submittingPos
  }

  return (
    <Button buttonType="submit" className={classnames(className, styles.base, buttonClasses)} disabled={disabledState} type={type} {...rest}>
      <span className={classnames(styles.icon, iconClasses)} >
        <IconSubmit />
      </span>
      <span className={classnames(styles.text, pos)}>
        <span className={classnames(styles.defaultText, (!submitting && !complete) && styles.textActive)}>{children}</span>
        <span className={classnames(styles.completeText, (complete) && styles.textActive)}>{completeText}</span>
        <span className={classnames(styles.submittingText, (submitting) && styles.textActive)}>{submittingText}</span>
      </span>
    </Button>
  )
}

SubmitButton.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  complete: PropTypes.bool,
  completeText: PropTypes.string,
  disabled: PropTypes.bool,
  isLarge: PropTypes.bool,
  submitting: PropTypes.bool,
  submittingText: PropTypes.string,
  type: PropTypes.string,
}

SubmitButton.defaultProps = {
  className: null,
  complete: false,
  completeText: 'Complete',
  isLarge: false,
  submitting: false,
  submittingText: 'Sending',
  type: 'primary',
}

export default SubmitButton



// WEBPACK FOOTER //
// ./src/components/SubmitButton/SubmitButton.js